import { useQuery } from "@apollo/client"
import constate from "constate"
import { useEffect, useState } from "react"
import { useLocalStorage } from "utils/hooks/useLocalStorage"
import { LIKE_TEAM_ACTION_QUERY } from "./queries"
import { LikeTeamActionQuery } from "__generated__/LikeTeamActionQuery"
import { ApplicationStatusEnum } from "__generated__/globalTypes"

const LOCAL_STORAGE_KEY = "modals.LikeTeamIntroductionModal"

/*
 * Should show LikeTeamAction by default. Even if no pallet slug is provided, show action.
 */
const [LikeTeamActionProvider, useLikeTeamAction] = constate(
    ({ pallet }: { pallet?: string }) => {
        const [seen, setSeen] = useLocalStorage(LOCAL_STORAGE_KEY)
        const [isIntroModalOpen, setIntroModalOpen] = useState<boolean>(false)
        const { data } = useQuery<LikeTeamActionQuery>(LIKE_TEAM_ACTION_QUERY, {
            variables: { pallet: pallet },
            skip: !pallet,
        })

        const group = data?.group
        const candidate = group?.activeMember
        const candidateIsRejected =
            !!candidate &&
            candidate.applicationStatusEnum === ApplicationStatusEnum.REJECTED

        const showLikeAction = !pallet || (!!group && !candidateIsRejected)
        const shouldShowApplication =
            !!group &&
            (!candidate ||
                candidate.applicationStatusEnum ===
                    ApplicationStatusEnum.INCOMPLETE)

        useEffect(() => {
            if (showLikeAction) setIntroModalOpen(!seen)
        }, [seen, showLikeAction, setIntroModalOpen])

        const showIntroModal = () => setIntroModalOpen(true)
        const hideIntroModal = () => {
            setSeen("true")
            setIntroModalOpen(false)
        }

        return {
            pallet,
            showLikeAction,
            shouldShowApplication,
            showIntroModal,
            hideIntroModal,
            isIntroModalOpen,
        }
    }
)

export { LikeTeamActionProvider, useLikeTeamAction }
